export default __webpack_public_path__ + "51138cc48e31022493c8d64cd18ea516.svg";